// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"8a320973","315":"60e9ab43","505":"022288da","702":"c97a751d","920":"4aa4d6e7"}[chunkId] + ".chunk.js";
};